import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomCheckBoxV2 from '../../../../components/CheckBoxV2/CheckBox';
import { LANG_TEXT } from '../../../../constants/language';
import CardLayout from '../card/CardLayout';
import { useStyles } from './styles';

import { ClientEmailContactingState } from '../../PreorderRules.types';

interface ClientEmailContactingProps {
  onChange?: (values: ClientEmailContactingState) => void;
  initialValues?: ClientEmailContactingState;
  resetKey?: number;
}

export default function ClientEmailContacting({ onChange, initialValues: propInitialValues, resetKey = 0 }: ClientEmailContactingProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const defaultInitialValues: ClientEmailContactingState = {
    his_success: true,
    his_deliver_unsuccess: true,
    his_delivered: true,
    other_success: true,
    other_deliver_unsuccess: true,
    other_delivered: true,
    gift_success: true,
    gift_deliver_unsuccess: true,
    gift_delivered: true,
  };

  const initialValues = propInitialValues || defaultInitialValues;
  const [values, setValues] = useState<ClientEmailContactingState>(initialValues);

  // Update values when prop changes (for reset)
  useEffect(() => {
    if (propInitialValues) {
      setValues(propInitialValues);
    }
  }, [propInitialValues, resetKey]);

  // Notify parent of changes
  useEffect(() => {
    onChange?.(values);
  }, [values, onChange]);

  const toggle = (key: keyof ClientEmailContactingState) => {
    setValues((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderCheck = (key: keyof ClientEmailContactingState, labelKey: string) => (
    <Box key={key} className={classes.checkboxRow}>
      <CustomCheckBoxV2 value={String(key)} checked={values[key]} setValue={() => toggle(key)} />
      <span className={classes.checkboxLabel}>{t(labelKey)}</span>
    </Box>
  );

  return (
    <CardLayout title={t(LANG_TEXT.CLIENT_EMAIL_CONTACTING)} label="">
      <Box display="flex" flexDirection="column" gap={4}>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography className={classes.columnTitle}>{t(LANG_TEXT.ORDER_FOR_HIM_HERSELF)}</Typography>
          {renderCheck('his_success', LANG_TEXT.ORDER_SUCCESS_EMAIL_CONFIRMATION)}
          {renderCheck('his_deliver_unsuccess', LANG_TEXT.UNSUCCESS_EMAIL_CONFIRMATION)}
          {renderCheck('his_delivered', LANG_TEXT.ORDER_DELIVERED_EMAIL_CONFIRMATION)}
        </Box>

        <Box display="flex" gap={4}>
          <Box display="flex" flexDirection="column" gap={1} flex={1}>
            <Typography className={classes.columnTitle}>
              {t(LANG_TEXT.ORDER_FOR_OTHER_SENDER)}
            </Typography>
            {renderCheck('other_success', LANG_TEXT.ORDER_SUCCESS_EMAIL_CONFIRMATION_TO_SENDER)}
            {renderCheck('other_deliver_unsuccess', LANG_TEXT.UNSUCCESS_EMAIL_CONFIRMATION_TO_SENDER)}
            {renderCheck('other_delivered', LANG_TEXT.ORDER_DELIVERED_EMAIL_CONFIRMATION_TO_SENDER)}
          </Box>

          <Box display="flex" flexDirection="column" gap={1} flex={1}>
            <Typography className={classes.columnTitle}>{t(LANG_TEXT.GIFT_NOTIFICATION_RECEIVER)}</Typography>
            {renderCheck('gift_success', LANG_TEXT.GAMEDAY_YOU_WILL_HAVE_A_GIFT_FROM_SENDER)}
            {renderCheck('gift_deliver_unsuccess', LANG_TEXT.UNSUCCESS_GIFT_FROM_SENDER)}
          </Box>
        </Box>
      </Box>
    </CardLayout>
  );
}
